import React from 'react';
import { FormInputsData } from '../../data/ProfileData';
import { FormCustom } from '../common';

export const Profile = () => {
  const formData = { list: FormInputsData, buttonSection: { isRequired: false } };
  return (
    <>
      <FormCustom {...formData} />
    </>
  );
};
export default Profile;
